// Default countdown/schedule timezone.
const DEFAULT_TZ = 'America/Los_Angeles'

// Max safe setTimeout delay (~24.8 days).
const MAX_TIMEOUT_MS = 2147483647

const getTimestampInTimezone = (year, month, day, hours, minutes, timezone) => {
  const date = new Date(Date.UTC(year, month - 1, day, hours, minutes))
  const invDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }))
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone: timezone }))
  const diff = tzDate.getTime() - invDate.getTime()
  return Math.floor((date.getTime() - diff) / 1000)
}

const parseDateTimeToEpoch = (dateStr, timeStr, timezone) => {
  if (!dateStr) return null
  const [year, month, day] = dateStr.split('-').map(Number)
  if (!year || !month || !day) return null
  const [hours, minutes] = (timeStr || '00:00').split(':').map(Number)
  return getTimestampInTimezone(year, month, day, hours || 0, minutes || 0, timezone)
}

const applyCountdownTimers = (root = document) => {
  root.querySelectorAll('.sale-countdown-banner__timer[data-pacific-end-date]').forEach((wrap) => {
    const timer = wrap.querySelector('.countdown-timer')
    if (!timer) return

    const timezone = wrap.dataset.timezone || DEFAULT_TZ
    const unix = parseDateTimeToEpoch(wrap.dataset.pacificEndDate, wrap.dataset.pacificEndTime, timezone)
    if (unix === null) return

    timer.dataset.time = String(unix)
  })

  window.initCountdownTimers?.()
}

// Auto show/hide banner by schedule (enable_scheduling).
const applyBannerScheduling = (root = document) => {
  root.querySelectorAll('.sale-countdown-banner[data-schedule-enabled="true"]').forEach((section) => {
    const timezone = section.dataset.scheduleTimezone || DEFAULT_TZ
    const startEpoch = parseDateTimeToEpoch(section.dataset.scheduleStartDate, section.dataset.scheduleStartTime, timezone)
    const endEpoch = parseDateTimeToEpoch(section.dataset.scheduleEndDate, section.dataset.scheduleEndTime, timezone)

    const now = Date.now() / 1000

    if ((startEpoch !== null && now < startEpoch) || (endEpoch !== null && now >= endEpoch)) {
      section.remove()
      return
    }

    if (endEpoch !== null) {
      const msRemaining = (endEpoch - now) * 1000
      if (msRemaining <= MAX_TIMEOUT_MS) {
        setTimeout(() => section.remove(), msRemaining)
      }
    }
  })
}

const initSaleCountdownBanners = (root = document) => {
  applyBannerScheduling(root)
  applyCountdownTimers(root)
}

document.addEventListener('DOMContentLoaded', () => {
  initSaleCountdownBanners()
})

document.addEventListener('shopify:section:load', (event) => {
  if (!event.target.querySelector('.sale-countdown-banner')) return
  initSaleCountdownBanners(event.target)
})
